// Axes de filtre partagés par la page Audit, la page Profil et la fiche « Gérer » d'un utilisateur :
// mêmes valeurs de type / niveau (celles du serveur), mêmes libellés français, mêmes raccourcis de
// période. Pur (aucun React) pour être testable.

export const TYPE_OPTIONS: Array<{ value: string; label: string }> = [
	{ value: "", label: "Toutes les actions" },
	{ value: "content-update", label: "Contenu (créations, éditions, suppressions)" },
	{ value: "content-deploy-preview", label: "Déploiement preview" },
	{ value: "content-deploy-production", label: "Déploiement production" },
	{ value: "content-unpublish-production", label: "Dépublication production" },
	{ value: "auth", label: "Connexions" },
	{ value: "rbac", label: "Permissions et rôles" },
	{ value: "user-change", label: "Comptes utilisateurs" },
	{ value: "storage-upload", label: "Médias" },
	{ value: "backup", label: "Sauvegardes" },
	{ value: "admin-maintenance", label: "Maintenance" }
];

export const LEVEL_OPTIONS: Array<{ value: string; label: string }> = [
	{ value: "", label: "Tous les niveaux" },
	{ value: "Information", label: "Information" },
	{ value: "Warning", label: "Avertissement" },
	{ value: "Error", label: "Erreur" }
];

export type PeriodKey = "7" | "30" | "90" | "all";

export const PERIOD_OPTIONS: Array<{ key: PeriodKey; label: string }> = [
	{ key: "7", label: "7 j" },
	{ key: "30", label: "30 j" },
	{ key: "90", label: "90 j" },
	{ key: "all", label: "Tout" }
];

/** Borne « since » (ISO UTC) d'un raccourci de période, calculée à partir de `now` ; undefined = tout. */
export function sinceForPeriod(period: PeriodKey, now: Date = new Date()): string | undefined {
	if (period === "all") return undefined;
	const days = Number(period);
	const d = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
	return d.toISOString();
}

/** Texte « x à y sur N » d'une page ; « 0 sur 0 » quand vide. */
export function pageRangeLabel(page: number, pageSize: number, total: number): string {
	if (total <= 0) return "0 sur 0";
	const from = (page - 1) * pageSize + 1;
	const to = Math.min(total, page * pageSize);
	return `${from.toLocaleString("fr-FR")} à ${to.toLocaleString("fr-FR")} sur ${total.toLocaleString("fr-FR")}`;
}

export function pageCount(total: number, pageSize: number): number {
	return Math.max(1, Math.ceil(Math.max(0, total) / Math.max(1, pageSize)));
}
